'use es6';

import text from 'I18n/utils/unescapedText';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Component } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { OPT_INTO_AUTOMATION_STEP, CHOOSE_PROVIDER_STEP, DETECT_PROVIDER_STEP } from 'InboxConnectUtils/constants/InboxConnectStepKeys';
import StepInterface from './StepInterface';
import { getClientKey } from '../../utils/InboxConnectionUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class DetectClientStep extends Component {
  componentDidMount() {
    this.props.trackingClient.trackStepView(DETECT_PROVIDER_STEP);
    const {
      service,
      setSelectedClient,
      setShownStep,
      emailAddress,
      setEmailAddress
    } = this.props;
    const request = emailAddress === '' ? () => service.getProvider() : () => service.getProviderByEmailAddress(emailAddress);
    request().then(provider => {
      const clientKey = getClientKey(provider.get('name'));
      if (clientKey !== null) {
        if (emailAddress === '') {
          setEmailAddress(provider.get('email'));
        }
        setSelectedClient(clientKey);
        setShownStep(OPT_INTO_AUTOMATION_STEP);
      } else {
        throw new Error('No client detectable.');
      }
    }).catch(() => {
      setShownStep(CHOOSE_PROVIDER_STEP);
    });
  }
  render() {
    const LANG_ROUTE = 'InboxConnectUtils.wizard.detectProvider';
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      "data-selenium": "detect-client-step",
      blockSize: "519px",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `${LANG_ROUTE}.title`
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          justifyContent: "center",
          children: [/*#__PURE__*/_jsx(LoadingSpinner, {
            display: "inline-block"
          }), /*#__PURE__*/_jsx(Text, {
            children: text(`${LANG_ROUTE}.detecting`)
          })]
        })]
      })
    });
  }
}
DetectClientStep.propTypes = StepInterface;